import { ColumnType } from "@/types/evaluate";
import { CodeIcon, LinkIcon, SparklesIcon } from "@heroicons/react/outline";
import React from "react";

interface HeaderIconProps {
  columnType: ColumnType;
  hasError?: boolean;
}

export const HeaderIcon: React.FC<HeaderIconProps> = ({
  columnType,
  hasError,
}) => {
  const iconClass = `mr-1 inline-block h-4 w-4 ${
    hasError ? "text-red-500" : "text-gray-600"
  }`;

  switch (columnType) {
    case ColumnType.ENDPOINT:
      return <LinkIcon className={iconClass} />;
    case ColumnType.PROMPT_TEMPLATE:
      return <SparklesIcon className={iconClass} />;
    case ColumnType.CODE_EXECUTION:
      return <CodeIcon className={iconClass} />;
    default:
      return null;
  }
};
